module.exports = __webpack_public_path__ + "img/dortoirA.55506720.jpg";